import { useSyncExternalStore } from 'react';

// Whether the desktop's chat-history rail is on screen. The desktop owns the
// rail; the shell, in another subtree, reads this to stand the streak pill
// aside: the rail runs down to the same lower-right corner the pill sits in.
let isShown = false;
const listeners = new Set<() => void>();
const getIsHistoryRailShown = (): boolean => isShown;

const subscribeHistoryRailShown = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const setHistoryRailShown = (next: boolean): void => {
  if (isShown === next) return;
  isShown = next;
  listeners.forEach((listener) => listener());
};

export const useIsHistoryRailShown = (): boolean =>
  useSyncExternalStore(
    subscribeHistoryRailShown,
    getIsHistoryRailShown,
    getIsHistoryRailShown
  );

/** The current value, outside React (tests). */
export const readHistoryRailShown = (): boolean => isShown;

/** Back to hidden (tests). */
export const resetHistoryRailShown = (): void => setHistoryRailShown(false);
